import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Login from "./Login";
import PageNotFound from "./PageNotFound";
import MainDoctorSignup from "./MainDoctorSignup";
import PrivateRoute from "../Components/PrivateRoute";
import AdminDashboard from "./AdminRoutes/AdminDashboard";
import AppointmentList from "./AdminRoutes/AppointmentList";
import Transaction from "./AdminRoutes/Transaction";
import AddAppointment from "./AdminRoutes/AddAppointment";
import AddExternalAppointment from "./publicRoutes/AddExternalAppointment";
import AddNewPatientExternal from "./publicRoutes/AddPatientExternal";
import AddPrescription from "./AdminRoutes/AddPrescription";
import VisualizeBoard from "./Visualization/DataVisulization";
import DoctorForm from "./AdminRoutes/DoctorForm";
import MainDoctorForm from "./AdminRoutes/MainDoctorForm";
import Table from "./AdminRoutes/Table";
import ReceptionistForm from "./AdminRoutes/ReceptionistForm";
import ConsultantForm from "./AdminRoutes/ConsultantForm";
import CustomerForm from "./AdminRoutes/PatientForm";
import EnquiryForm from "./AdminRoutes/EnquiryForm";
import AssistantDoctorForm from "./AdminRoutes/AssistantDoctorForm";
import InventoryPanel from "./Inventory/mainInventory";
import DistributorForm from "./Inventory/DistributorForm";
import DistributorCompaniesList from "./Inventory/companiesFormList";
import OrderForm from "./Inventory/OrderForm";
import ReturnForm from "./Inventory/ReturnForm";
import { Classical_Homeopathy } from "../coverPage/AllPages/Classical_Homeopathy";
import { TreatmentPackage } from "../coverPage/AllPages/TreatmetnPackages";
import { HealthPackage } from "../coverPage/AllPages/Health_Package";
import { ThearapyPackage } from "../coverPage/AllPages/Alternative_Therapies";
import { Testimonials } from "../coverPage/AllPages/Testimonials";
import { OnlineClinic } from "../coverPage/AllPages/onlineClinic";
import { ContactUs } from "../coverPage/AllPages/contact_us";
import { PrivacyPolicy } from "../coverPage/AllPages/privacy_policy";
import { Webpages } from "../coverPage/coverRoute";
import { FeedBack } from "./publicRoutes/FeedBack";
import Popup from "./publicRoutes/Popup";
import AfterActionComponent from "./publicRoutes/actionView";
import FeedbackList from "../Routes/AdminRoutes/FeedbackList";
import UpdateAppointment from "./AdminRoutes/UpdateAppointment";
import PatientReports from "./AdminRoutes/patientReports";
import UploadPatientReports from "./publicRoutes/AddPatientReports";
import Nutrion from "./publicRoutes/alternative_therapies/nutrion";
import AlternativeTherapies from "./AdminRoutes/Alternative_Therapies/AlternativeTherapies";
import Bids from "./AdminRoutes/BIDS/Bids";
import AddBids from "./AdminRoutes/BIDS/CreateBid";
import ReviewBid from "./AdminRoutes/BIDS/ReviewBid";
import AlternativeTherapiesList from "./AdminRoutes/Alternative_Therapies/AlternativeTherapiesList";
import CreateTherapyRequest from "./AdminRoutes/Alternative_Therapies/CreateTherapyRequest";
import UpdateAlternativeTherapy from "./AdminRoutes/Alternative_Therapies/UpdateAlternativeTherapy";
import BidsTable from "./AdminRoutes/BIDS/BidsTable";
import ClinicProfile from "./AdminRoutes/ClinicProfile";
import Plans from "./MasterRoutes/Plans";
import SiteConfig from "./AdminRoutes/SiteConfig";
import Permissions from "./AdminRoutes/Permissions";
import Users from "./MasterRoutes/Users";
import IncomeExpensesPanel, { INCOME_EXPENSES_SECTIONS } from "./AdminRoutes/IncomeExpensesPanel";
import Certificates from './AdminRoutes/Certificates/Certificate';
import PatientSearch from './AdminRoutes/PatientSearch/PatientSearch';
import Calendar from './AdminRoutes/calender';
import AttendanceLeaves from './AdminRoutes/AttendanceLeaves';
import LeaveCalendar from './AdminRoutes/LeaveCalendar';
import StaffManagement from "./AdminRoutes/attendenceprofile";
import AttendanceCalendar from "./AdminRoutes/AttendanceCalendar";
import QuestionsFormData from './FormData/QuestionsFromForm';
import TestimonialFormData from './FormData/TestimonialFormData';
import ShareThoughtsFormData from './FormData/ThoughtsFormData';
import EnrolledHealthFormData from './FormData/EnrolledHealthPackages';
import CalmEczemaNaturallyFormData from './FormData/CalmEczemaNaturally';
import CallBacksFormData from './FormData/CallBack';
import BookAlternativePackageFormData from './FormData/BookAlternativeTherapies';
import DropDownOption from './DropDown';
import LoginProfile from "./AdminRoutes/LoginProfile";
import VideoConsultation from "./AdminRoutes/VideoConsultation";
import VideoConsultationList from "./AdminRoutes/VideoConsultationList";
import PatientVideoConsultation from "./publicRoutes/PatientVideoConsultation";
import PatientProfile from "./AdminRoutes/PatientProfile/PatientProfile";
import VitalTemplates from "./AdminRoutes/Vitals/VitalTemplates";
import PatientPortal from "./publicRoutes/PatientPortal";
import CourierList from "./AdminRoutes/Courier/CourierList";
import TrackShipment from "./publicRoutes/TrackShipment";
import PublicPatientUpdate from "./publicRoutes/PublicPatientUpdate";
import SharedCertificate from "./publicRoutes/SharedCertificate";
import LabReportUpload from "./publicRoutes/LabReportUpload";
import ResetPasswordLink from "./publicRoutes/ResetPasswordLink";
import SsoLogin from "./publicRoutes/SsoLogin";

export default function AllRoutes() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Login />} />
            <Route path="/signup" element={<MainDoctorSignup />} />
            <Route path="login" element={<Login />} />
            {/* Single-login handoff from the landing site; reads the session from the URL fragment */}
            <Route path="sso" element={<SsoLogin />} />
            <Route path="certificates" element={<PrivateRoute><Certificates /></PrivateRoute>} />
            <Route path="patient-search" element={<PrivateRoute><PatientSearch /></PrivateRoute>} />
            <Route path="referral-business" element={<Navigate to="/income_expenses/referral-business" replace />} />
            <Route path="courier" element={<PrivateRoute><CourierList /></PrivateRoute>} />
            {/* Patient facing: the token in the URL is the only credential */}
            <Route path="track/:trackingToken" element={<TrackShipment />} />
            <Route path="attendancecount" element={<PrivateRoute><AttendanceLeaves /></PrivateRoute>} />
            <Route path="attendancerequests" element={<PrivateRoute><AttendanceLeaves /></PrivateRoute>} />
            <Route path="leavecalendar" element={<PrivateRoute><LeaveCalendar /></PrivateRoute>} />
            <Route path="calendar" element={<PrivateRoute><Calendar /></PrivateRoute>} />
            <Route path="staffprofile" element={<PrivateRoute><StaffManagement /></PrivateRoute>} />
            <Route path="attendancecalendar" element={<PrivateRoute><AttendanceCalendar /></PrivateRoute>} />
            <Route
              path="login-profile"
              element={
                <PrivateRoute>
                  <LoginProfile />{' '}
                </PrivateRoute>
              }
            ></Route> 




             <Route path="web" element={<Webpages />}>
              <Route path="classical_homeopathy" element={<Classical_Homeopathy />} />
              <Route path="treatmentPackage/:treatmentType/:topic" element={<TreatmentPackage />} />
              <Route path="alternative_therapies/:threapyType" element={<ThearapyPackage />} />
              <Route path="health_packages/:packageType" element={<HealthPackage />} />
              <Route path="testimonials/:testimonialType" element={<Testimonials />} />
              <Route path="online_clinic/:ocType" element={<OnlineClinic />} />
              <Route path="contact_us" element={<ContactUs />} />
              <Route path="privacy_policy" element={<PrivacyPolicy />} />
              <Route path="feedback" element={<FeedBack />} />
              <Route path="popup" element={<Popup />} />
              <Route path="afterAction" element={<AfterActionComponent />} />
              <Route path="aggrement" element={<AfterActionComponent />} />

            </Route>
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  {" "}
                  <AdminDashboard />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="/enquiry/:Enquiry_Id"
              element={
                <PrivateRoute>
                  <EnquiryForm />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="/appointment"
              element={
                <PrivateRoute>
                  <AddAppointment />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="/appointment/:appointmentId/:doctor_id"
              element={
                <PrivateRoute>
                  <UpdateAppointment />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="/video-consultation"
              element={
                <PrivateRoute>
                  <VideoConsultationList />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="/video-consultation/:appointmentId"
              element={
                <PrivateRoute>
                  <VideoConsultation />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="/prescription/add/:patientId"
              element={
                <PrivateRoute>
                  <AddPrescription />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="/main-doctor"
              element={
                <PrivateRoute>
                  <MainDoctorForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/main-doctor/:id"
              element={
                <PrivateRoute>
                  <MainDoctorForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/mainDoctor/profile"
              element={
                <PrivateRoute>
                  <MainDoctorForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/doctors/:Doctor_Id"
              element={
                <PrivateRoute>
                  <DoctorForm />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="/assistantDoctor/:AssistantDoctor_Id"
              element={
                <PrivateRoute>
                  <AssistantDoctorForm />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="/patients/:patientId"
              element={
                <PrivateRoute>
                  <CustomerForm />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="/patients/:patientId/reports"
              element={
                <PrivateRoute>
                  <PatientReports />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="/patients/:patientId/profile"
              element={
                <PrivateRoute>
                  <PatientProfile />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="/vitals-templates"
              element={
                <PrivateRoute>
                  <VitalTemplates />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="AlternativeTherapies"
              element={
                <PrivateRoute>
                  <AlternativeTherapiesList />{" "}
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="Bids"
              element={
                <PrivateRoute>
                  <BidsTable />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/:listType"
              element={
                <PrivateRoute>
                  <Table />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="/receptionist/:receptionist_Id"
              element={
                <PrivateRoute>
                  <ReceptionistForm />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="/appointment/list"
              element={
                <PrivateRoute>
                  <AppointmentList />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="/transaction"
              element={
                <PrivateRoute>
                  <Transaction />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="/consultant/:consultant_id"
              element={
                <PrivateRoute>
                  <ConsultantForm />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="/graphs"
              element={
                <PrivateRoute>
                  <VisualizeBoard />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="/income_expenses"
              element={
                <PrivateRoute sections={INCOME_EXPENSES_SECTIONS}>
                  <IncomeExpensesPanel />
                </PrivateRoute>
              }
            />
            <Route
              path="/income_expenses/:tab"
              element={
                <PrivateRoute sections={INCOME_EXPENSES_SECTIONS}>
                  <IncomeExpensesPanel />
                </PrivateRoute>
              }
            />
            <Route
              path="main/inventory/:section/:inventory_item_id"
              element={
                <PrivateRoute>
                  <InventoryPanel />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="main/inventory/:section"
              element={
                <PrivateRoute>
                  <InventoryPanel />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="main/inventory/Order/addNew"
              element={
                <PrivateRoute>
                  <OrderForm />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="main/inventory/Returns/addNew"
              element={
                <PrivateRoute>
                  <ReturnForm />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="main/inventory/:section/Order/:inventory_item_id"
              element={
                <PrivateRoute>
                  <OrderForm />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="main/inventory/:section/Order/:inventory_item_id/:medicine_id"
              element={
                <PrivateRoute>
                  <OrderForm />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="main/inventory/:section/Returns/:inventory_item_id"
              element={
                <PrivateRoute>
                  <ReturnForm />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="main/inventory/:section/Returns/:inventory_item_id/:order_id"
              element={
                <PrivateRoute>
                  <ReturnForm />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="main/inventory/:section/Distributors/:inventory_item_id"
              element={
                <PrivateRoute>
                  <DistributorForm />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="main/inventory/:section/Distributors/companies/:company_name/:company_id"
              element={
                <PrivateRoute>
                  <DistributorCompaniesList />{" "}
                </PrivateRoute>
              }
            />
            <Route
              path="feedback/:feedback_id"
              element={
                <PrivateRoute>
                  <FeedbackList />{" "}
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="AlternativeTherapies/new"
              element={
                <PrivateRoute>
                  <CreateTherapyRequest />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="AlternativeTherapies/:therapy_id"
              element={
                <PrivateRoute>
                  <AlternativeTherapies />{" "}
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="AlternativeTherapies/:therapy_id/update"
              element={
                <PrivateRoute>
                  <UpdateAlternativeTherapy />{" "}
                </PrivateRoute>
              }
            ></Route>
            <Route path="Bids/:bid_id" element={<PrivateRoute>{<Bids />}</PrivateRoute>}></Route>
            <Route path="Bids/review/:bid_id" element={<PrivateRoute>{<ReviewBid />}</PrivateRoute>}></Route>
            <Route
              path="Bids/:bid_id/create"
              element={
                <PrivateRoute>
                  <AddBids />{" "}
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="clinic-profile"
              element={
                <PrivateRoute>
                  <ClinicProfile />{" "}
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="subscription"
              element={<Navigate to="/clinic-profile" replace />}
            />
            <Route
              path="site-config"
              element={
                <PrivateRoute>
                  <SiteConfig />{" "}
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="permissions"
              element={
                <PrivateRoute>
                  <Permissions />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="plans"
              element={
                <PrivateRoute>
                  <Plans />{" "}
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="consultant/Bids"
              element={
                <PrivateRoute>
                  <BidsTable />
                </PrivateRoute>
              }
            ></Route>




        <Route
          path="/CallBack"
          element={
            <PrivateRoute allowedRoles={['SuperAdmin']}>
              <CallBacksFormData />{' '}
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="Questions"
          element={
            <PrivateRoute>
              <QuestionsFormData />{' '}
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="Testimonials"
          element={
            <PrivateRoute allowedRoles={['SuperAdmin']}>
              <TestimonialFormData />{' '}
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="SharedThoughts"
          element={
            <PrivateRoute allowedRoles={['SuperAdmin']}>
              <ShareThoughtsFormData />{' '}
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="EnrolledInHealthPackages"
          element={
            <PrivateRoute allowedRoles={['SuperAdmin']}>
              <EnrolledHealthFormData />{' '}
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="CalmYourEczemaNaturally"
          element={
            <PrivateRoute>
              <CalmEczemaNaturallyFormData />{' '}
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="BookAlternativeTherapies"
          element={
            <PrivateRoute allowedRoles={['SuperAdmin']}>
              <BookAlternativePackageFormData />{' '}
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="DropDowns"
          element={
            <PrivateRoute allowedRoles={['SuperAdmin']}>
              <DropDownOption />{' '}
            </PrivateRoute>
          }
        ></Route>

        {/* External Public Routes */}
        <Route path="reset-password/:token" element={<ResetPasswordLink />} />
        <Route path="public/consult/:token" element={<PatientVideoConsultation />} />
        <Route path="public/portal/:token" element={<PatientPortal />} />
        <Route path="public/certificate/:token" element={<SharedCertificate />} />
        <Route path="public/lab-upload/:token" element={<LabReportUpload />} />
        <Route path="public/patients/addNew" element={<AddNewPatientExternal />} />
        <Route path="public/patient/update/:patientId" element={<PublicPatientUpdate />} />
        <Route path="/public/patient/update/:patientId" element={<PublicPatientUpdate />} />
        <Route path="public/appointment" element={<AddExternalAppointment />} />
        <Route path="public/patients/reports" element={<UploadPatientReports />} />
        <Route path="public/patients/reports/:formId/:patientId" element={<UploadPatientReports />} />
        <Route path="public/patients/feedback/:patientId" element={<FeedBack />} />
        <Route path="public/patients/feedback" element={<FeedBack />} />
        <Route path="public/diet/:patientId" element={<Nutrion therapy="nutrition" />} />
        <Route path="public/afterAction" element={<AfterActionComponent />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
}
